var _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 490.31761,
    height: 471.49999,
    viewBox: "0 0 490.31761 471.49999",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M375.32036,471.49999l3.40228-63.28253s111.59497-23.13556,111.59497-89.82037-182.36255-74.85031-200.73486-44.22974c-.18372,.30621-.36633,.61237-.54779,.91843-22.69257,38.27042-9.88062,87.95544,28.73438,110.05649,13.20422,7.55737,28.94763,14.02435,47.34418,17.6315l-1.29584,67.2262",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.81761,
    cy: 63,
    r: 63,
    fill: "#ff6884"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.87596,456.49895l-71.05322-4.5293-3.83154-319.50098c-.09277-7.75488,2.99902-15.34863,8.4834-20.83301L188.5952,35.51506c10.65576-10.65479,27.42725-11.4248,39.01318-1.78662l82.60742,68.71826c6.73926,5.60596,10.54541,13.84863,10.44189,22.61427l-2.83838,240.28076,35.90381,49.86621,.07617,.10547,6.0835,52.72363-181.00684-11.53809Z",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.45213,134.41953v-14.81543c0-3.91064,3.18164-7.09229,7.09229-7.09229h20.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v14.81543c0,3.91064-3.18115,7.09229-7.0918,7.09229h-20.81592c-3.91064,0-7.09229-3.18164-7.09229-7.09229Z",
    fill: "#007dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.47411,353.21865c-3.72461-.13184-6.72803-3.1543-6.83838-6.87988l-1.55811-52.98145c-.06641-2.26172,.9126-4.36328,2.68604-5.76855,1.77344-1.4043,4.04443-1.87305,6.23096-1.29297l1.55811,.41602c3.09961,.82715,5.26465,3.64453,5.26465,6.85254v52.56641c0,1.94141-.76953,3.75391-2.1665,5.10254-1.33496,1.28906-3.07275,1.98926-4.91846,1.98926-.08594,0-.17188-.00098-.2583-.00391Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.81743,345.90813v-54.97461c0-3.88086,3.03955-6.99512,6.91943-7.09082l28.0083-.68262c3.88232-.05371,7.14893,2.99316,7.2627,6.88477l1.61328,55.65723c.05566,1.93262-.65527,3.76074-2.00293,5.14746-1.34668,1.38672-3.15332,2.15039-5.08643,2.15039h-29.62207c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.36516,383.47341l21.95245,39.02658,2.52002,43.89001,17.47998,1.10999-6-52-36-50h0c-3.10706,5.59271-3.08905,12.39722,.04755,17.97342Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.89046,
    y: 454.31523,
    width: 71.25525,
    height: 1.00009,
    transform: "translate(-6.18903 4.21911) rotate(-.78329)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.26167,
    y: 445.26647,
    width: 67.55676,
    height: 1.00003,
    transform: "translate(-3.47316 2.38101) rotate(-.44761)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.69155,
    y: 436.6149,
    width: 64.63184,
    height: 1.00018,
    transform: "translate(-8.47841 5.9613) rotate(-1.11892)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.24518,
    y: 428.04499,
    width: 62.08985,
    height: 1.00055,
    transform: "translate(-14.05581 10.20111) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.67795,
    y: 420.0766,
    width: 59.659,
    height: 1.00061,
    transform: "translate(-14.59251 10.74761) rotate(-2.01348)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.2462,
    y: 412.00033,
    width: 58.07129,
    height: 1,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.87917,
    y: 405.3138,
    width: 56.44,
    height: 1.00006,
    transform: "translate(-4.73515 3.46236) rotate(-.6714)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.61627,
    y: 398.89655,
    width: 54.71588,
    height: 1.00055,
    transform: "translate(-13.09366 9.87591) rotate(-1.9017)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.31288,
    y: 391.50023,
    width: 54.00928,
    height: 1.00015,
    transform: "translate(-6.84489 5.14543) rotate(-1.00705)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.59824,
    y: 384.90729,
    width: 51.73132,
    height: 1.00049,
    transform: "translate(-11.89833 9.13568) rotate(-1.78991)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.06626,
    y: 378.25032,
    width: 51.25244,
    height: 1.00006,
    transform: "translate(-3.68497 2.79812) rotate(-.55951)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.31743,357.40813v-67.81543c0-3.91113,3.18164-7.09277,7.09229-7.09277h32.81592c3.91064,0,7.0918,3.18164,7.0918,7.09277v67.81543c0,3.91016-3.18115,7.0918-7.0918,7.0918h-32.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#007dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.87596,456.49895l-58.09033-3.7002-.46826-.03027v-44.95703c0-5.68555,4.62549-10.31152,10.31104-10.31152h57.37793c5.68555,0,10.31104,4.62598,10.31104,10.31152v48.68848h-.5l-18.94141-.00098Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.31743,234.40812v-51.81592c0-3.91064,3.18164-7.09229,7.09229-7.09229h10.81592c3.91064,0,7.0918,3.18164,7.0918,7.09229v51.81592c0,3.91016-3.18115,7.0918-7.0918,7.0918h-10.81592c-3.91064,0-7.09229-3.18164-7.09229-7.0918Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.31761,461.49999l-3-44-9-42-2.5-11.5h0c-5.13733-3.49338-12.05536,.39255-11.74512,6.59735l.24512,4.90265,9,42,3,44",
    fill: "#ccc"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.44666,110.38788v106c0,9.37402-7.62598,17-17,17H67.44666c-9.37402,0-17-7.62598-17-17V110.38788c0-9.37402,7.62598-17,17-17h106c9.37402,0,17,7.62598,17,17Zm-23.57587,121c11.91602,0,21.57587-9.65985,21.57587-21.57584v-46.86511c0-37.31183-30.24719-67.55905-67.55902-67.55905h-53.44095c-8.28427,0-15,6.71573-15,15v91.2106c0,16.45221,13.33716,29.78937,29.78937,29.78937h84.6348v.00003h-.00006Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.55713,136.68008h-34.22061c-.86273,0-1.5647-.702-1.5647-1.56473s.702-1.56439,1.5647-1.56439h34.22061c.86273,0,1.56439,.70166,1.56439,1.56439s-.70166,1.5647-1.56439,1.5647v.00003Z",
    fill: "#007dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.55713,170.04373h-34.22061c-.86273,0-1.5647-.702-1.5647-1.56473s.702-1.56439,1.5647-1.56439h34.22061c.86273,0,1.56439,.70166,1.56439,1.56439s-.70166,1.5647-1.56439,1.5647v.00003Z",
    fill: "#007dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.55713,216.04373h-34.22061c-.86273,0-1.5647-.702-1.5647-1.56473s.702-1.56439,1.5647-1.56439h34.22061c.86273,0,1.56439,.70166,1.56439,1.56439s-.70166,1.5647-1.56439,1.5647v.00003Z",
    fill: "#007dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.92029,153.37283H81.97339c-.86273,0-1.5647-.702-1.5647-1.56473s.702-1.56439,1.5647-1.56439h70.9469c.86273,0,1.56439,.70166,1.56439,1.56439s-.70166,1.5647-1.56439,1.5647v.00003Z",
    fill: "#007dff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.30957,338.49185C71.46582,338.49185,0,267.02603,0,179.18276S71.46582,19.87417,159.30957,19.87417s159.30859,71.46533,159.30859,159.30859-71.46582,159.30908-159.30859,159.30908Zm-.00001-316.61768C64.56828,223.29978,1.32341,109.477,1.99999,179.18278c.84189,86.73663,70.56837,157.30907,157.30958,157.30907s157.30859-70.56836,157.30859-157.30908S246.04982,21.87417,159.30956,21.87417Z",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationReview);
export default __webpack_public_path__ + "static/media/location_review.1f96ed3921dd21ca12bcfebfff5cd360.svg";
export { ForwardRef as ReactComponent };